const redReactivityAndInstabilityHazards = new Set([
  'H260',
  'H261',
  'H250',
  'H271',
  'H272',
  'H200',
  'H201',
  'H202',
  'H203',
  'H240',
  'H241',
  'H242',
  'H251',
  'H252',
]);

const rules = [
  {
    description: 'Flammable gas generation',
    matcher: {
      hazards: ['H260', 'H261'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 3,
      },
      {
        lessThan: 0.003,
        score: 5,
      },
      {
        lessThan: +Infinity,
        score: 10,
      },
    ],
  },
  {
    description: 'Pyrophoric',
    matcher: {
      hazards: ['H250'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 3,
      },
      {
        lessThan: 0.003,
        score: 6,
      },
      {
        lessThan: +Infinity,
        score: 10,
      },
    ],
  },
  {
    description: 'Oxidizer',
    matcher: {
      hazards: ['H270', 'H271', 'H272'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 1,
      },
      {
        lessThan: 0.003,
        score: 3,
      },
      {
        lessThan: +Infinity,
        score: 6,
      },
    ],
  },
  {
    description: 'Explosive / Self-heating',
    matcher: {
      hazards: [
        'H200',
        'H201',
        'H202',
        'H203',
        'H240',
        'H241',
        'H242',
        'H251',
        'H252',
      ],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 3,
      },
      {
        lessThan: 0.003,
        score: 5,
      },
      {
        lessThan: +Infinity,
        score: 10,
      },
    ],
  },
  {
    description: 'Corrosive',
    matcher: {
      hazards: ['H314'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 0.5,
      },
      {
        lessThan: 0.003,
        score: 1,
      },
      {
        lessThan: +Infinity,
        score: 2,
      },
    ],
  },
  {
    description: 'No reactivity or instability hazards known',
    matcher: {},
    masses: [
      {
        lessThan: +Infinity,
        score: 0,
      },
    ],
  },
];

export function appendReactivityAndInstability(reagents, report) {
  // what is the worse hazard ?
  let sum = 0;
  let redReactivityAndInstabilities = new Set();
  for (const rule of rules) {
    for (const reagent of reagents) {
      if (!reagent.safety.reactivityAndInstabilities) {
        reagent.safety.reactivityAndInstabilities = [];
      }

      const matching = isMatching(reagent, rule);
      appendRed(reagent, redReactivityAndInstabilities);
      if (!matching) continue;
      const score = rule.masses.find(
        (mass) => reagent.mass.value <= mass.lessThan,
      ).score;

      if (score > 0 || reagent.safety.reactivityAndInstabilities.length === 0) {
        reagent.safety.reactivityAndInstabilities.push({
          description: rule.description,
          matchingHazards: matching.matchingHazards || [],
          score,
        });
        sum += score;
      }
    }
  }
  report.redReactivityAndInstabilities = [...redReactivityAndInstabilities];
  report.scores.reactivityAndInstability = sum;
}

function appendRed(reagent, redReactivity) {
  for (const hazard of reagent.hazards) {
    if (redReactivityAndInstabilityHazards.has(hazard)) {
      redReactivity.add(hazard);
    }
  }
}

function isMatching(reagent, rule) {
  if (!rule.matcher.hazards) return true;
  const matchingHazards = rule.matcher.hazards.filter((hazard) =>
    reagent.hazards.includes(hazard),
  );
  if (matchingHazards.length === 0) return false;
  return {
    matchingHazards,
  };
}
